import React from 'react';

import { createStyles } from 'utils/createStyle';
import { Recipient } from './BulkOrderContext';
import { Modal, ModalSize } from 'components/modal/Modal';

import type { ModalControls } from 'hooks/useModalControls';

const styles = createStyles({
    recipientListScrollContent: [
        'grid overflow-y-scroll',
        {
            gridColumn: '1 / -1',
            maxHeight: '45vh',
            gridTemplateColumns: 'auto 1fr 1fr',
            scrollbarWidth: 'thin' /* For Firefox */,
            scrollbarColor: 'transparent transparent' /* For Firefox */,
            '::-webkit-scrollbar': {
                width: '8px' /* For Chrome, Safari, and Opera */,
            },
            '::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(0, 0, 0, 0.2)' /* For Chrome, Safari, and Opera */,
                borderRadius: '20px',
            },
            '::-webkit-scrollbar-track': {
                backgroundColor: 'transparent' /* For Chrome, Safari, and Opera */,
            },
        },
    ],
    recipientListContainer: [
        'border rounded ounded-lg border-grey-line mt-8 mx-auto',
        { boxShadow: '0px 18px 32px rgba(208, 210, 218, 0.15)' },
    ],
    recipientListData: ['grid text-align-left', { gridTemplateColumns: 'auto 1fr 1fr' }],
    recipientListFooter: [
        '',
        {
            boxShadow:
                '0px 0px 16px -4px rgba(16, 24, 40, 0.08), 0px -2px 6px -2px rgba(16, 24, 40, 0.03)',
        },
    ],
});

export const RecipientListModal = ({
    modalControls,
    recipients,
    fileName,
}: {
    modalControls: ModalControls;
    recipients: Recipient[];
    fileName?: string;
}) => {
    const headerStyles =
        'text-left text-xs font-semibold text-grey-medium bg-grey-50 inline px-6 py-3.5';
    const dataStyles =
        'border-b border-grey-line text-left text-grey-medium text-base inline px-6 py-3.5';
    return (
        <Modal
            title=""
            isOpen={modalControls.isVisible}
            onClose={modalControls.toggleModalVisibility}
            size={[ModalSize.LARGE, ModalSize.LARGE]}
        >
            <div className="text-center">
                <h1 className="text-brand-dark font-semibold text-29px">Recipient Details</h1>
                <p className="text-lg text-grey-medium mt-2">
                    File: <span className="font-semibold">{fileName}</span>
                </p>
                <div className={styles.recipientListContainer}>
                    <div className={styles.recipientListData}>
                        <p className={headerStyles}></p>
                        <p className={headerStyles}>Recipient Name</p>
                        <p className={headerStyles}>Recipient Email</p>
                        <div className={styles.recipientListScrollContent}>
                            {recipients.map((recipient: Recipient, index: number) => (
                                <React.Fragment key={index}>
                                    <span className={dataStyles}>{index + 1}</span>
                                    <span className={dataStyles}>{recipient.name}</span>
                                    <span className={dataStyles}>{recipient.email}</span>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                    <div className={styles.recipientListFooter}>
                        <p className="py-5 text-grey-medium">
                            <span className="font-semibold">{recipients.length}</span> Recipients
                        </p>
                    </div>
                </div>
                <button
                    className="mt-12 underline text-brand text-lg font-semibold mb-5"
                    onClick={modalControls.toggleModalVisibility}
                >
                    Close
                </button>
            </div>
        </Modal>
    );
};
